export const AppConstants = {
    SITE_ADDR: "http://localhost:3001",
    WEB_SERVICE_URL: "https://livecode-api.snappfood.ir/info",
    START_TASK:"/v1/user/start",
    UPLOAD:"/v1/user/upload",
    GET:"/v1/user",
}

export function GetWebServiceUrl(path,before) {
    return AppConstants.WEB_SERVICE_URL + path+"/"+before;
}


const GetAccessToken = () => {
    console.log("GET ACCESS TOKEN")
    let cookies = document.cookie.split(";")
    for (const cookie of cookies) {
        let c = cookie.split("=")
        if (c[0] === "access_token") {
            return c[1]
        }
    }
    return ""
}

export function CustomHeaderToken(token){
    return {
        headers: { Authorization: `Bearer ${token}` }
    }
}

export function LoginBasicAuth(username, password) {
    return {
        auth: {
            username: username,
            password: password
        }
    }
}